(() => {
  // node_modules/loadx/dist/loadx.module.js
  var n = function() {
    var n2 = {};
    function r(r2, t, e) {
      return new Promise(function(o, u) {
        if (t === null || !(t instanceof HTMLElement))
          return u(new Error("Parent not found."));
        var c = function(r3) {
          var t2 = JSON.stringify(r3), e2 = n2[t2];
          return e2 !== void 0 ? e2 : null;
        }(e);
        if (c !== null)
          return o(c);
        var i = document.createElement(r2);
        i.onload = function() {
          o(i), function(r3, t2) {
            var e2 = JSON.stringify(r3);
            n2[e2] = t2;
          }(e, i);
        }, i.onerror = function(n3) {
          u(new URIError("The asset " + n3.target.src + " didn't load correctly."));
        }, Object.keys(e).forEach(function(n3) {
          i[n3] = e[n3];
        }), t.appendChild(i);
      });
    }
    return r.js = function(n3) {
      return r("script", document.body, { src: n3 });
    }, r.css = function(n3) {
      return r("link", document.head, { type: "text/css", rel: "stylesheet", href: n3 });
    }, r.img = function(n3, t) {
      return r("img", function(n4) {
        return n4 === void 0 ? document.body : n4;
      }(t), { src: n3 });
    }, r;
  }();
  var loadx_module_default = n;

  // src/js/components/lightbox.js
  var Lightbox = class {
    constructor(element, lightbox) {
      this.element = element;
      this.lightbox = lightbox;
    }
    static async init() {
      const lightboxes = window.Store.app.theBody.querySelectorAll(".js-lightbox");
      if (!lightboxes.length)
        return null;
      if (!window.Store.components.lightbox.cdn_is_loaded) {
        await loadx_module_default.css("https://cdn.jsdelivr.net/npm/glightbox/dist/css/glightbox.min.css");
        await loadx_module_default.js("https://cdn.jsdelivr.net/gh/mcstudios/glightbox/dist/js/glightbox.min.js");
        window.Store.components.lightbox.cdn_is_loaded = true;
      }
    }
    static create() {
      const lightboxes = window.Store.app.theBody.querySelectorAll(".js-lightbox");
      if (!lightboxes.length)
        return null;
      let lightboxes_tree = [];
      lightboxes.forEach((lightbox) => {
        const customLightboxHTML = `
                <div id="glightbox-body" class="glightbox-container c-lightBoxVid">
                    <div class="gloader visible"></div>
                    <div class="goverlay c-lightBoxVid__overlay"></div>
                    <div class="c-lightBoxVid__inner">
                        <div class="gcontainer c-lightBoxVid__container">
                            <div id="glightbox-slider" class="gslider"></div>
                            <button class="gnext gbtn" style="display: none; pointer-events: none;" tabindex="0"></button>
                            <button class="gprev gbtn" style="display: none; pointer-events: none;" tabindex="1"></button>
                            <button class="c-lightBoxVid__closeBtn gclose gbtn" tabindex="2"></button>
                        </div>
                    </div>
                </div>
            `;
        const glightbox = GLightbox({
          selector: `.${lightbox.className}`,
          autoplayVideos: false,
          touchNavigation: false,
          videosWidth: 100 + "%",
          lightboxHTML: customLightboxHTML,
          closeOnOutsideClick: true,
          plyr: {
            config: {
              ratio: "16:9",
              muted: false,
              youtube: {
                noCookie: true,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3
              }
            }
          }
        });
        const obj = new Lightbox(lightbox, glightbox);
        lightboxes_tree.push(obj);
      });
      window.Store.components.lightbox.obj = lightboxes_tree;
    }
  };
  function render() {
    Lightbox.init().then(() => {
      Lightbox.create();
    });
  }
  window.Store.components.lightbox = {
    obj: null,
    render: null,
    cdn_is_loaded: false
  };
  window.Store.components.lightbox.render = render;
})();
